import { useState, useEffect } from "react";
import { Col, Row, Alert } from "react-bootstrap";

export const Newsletter = ({ status, message, onValidated }) => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); // Ajouter un état pour suivre l'état du bouton

    useEffect(() => {
        if (status === 'success') {
            clearFields();
            setIsSubmitting(false); // Réinitialiser l'état quand la soumission réussit
        }
    }, [status]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email && email.indexOf("@") > -1) {
            setIsSubmitting(true); // Définir isSubmitting sur true dès que l'utilisateur soumet
            setTimeout(() => {
                // Lancer la soumission après un délai de 500ms
                onValidated({
                    EMAIL: email
                });
            }, 500); // 500ms de délai avant de lancer onValidated
        }
    };

    const clearFields = () => {
        setEmail('');
    };

    return (
        <Col lg={12}>
            <div className="newsletter-bx wow slideInUp">
                <Row>
                    <Col lg={12} md={6} xl={5}>
                        <h3>Stay Updated on My Latest Work & Achievements</h3>
                        {status === 'sending' && <Alert>Sending...</Alert>}
                        {status === 'error' && <Alert variant="danger">{message}</Alert>}
                        {status === 'success' && <Alert variant="success">{message}</Alert>}
                    </Col>
                    <Col md={6} xl={7}>
                        <form onSubmit={handleSubmit}>
                            <div className="new-email-bx">
                                <input
                                    value={email}
                                    type="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email Address"
                                />
                                <button type="submit" className="submit-btn">
                                    {isSubmitting ? "Submitting..." : "Submit"} {/* Afficher "Submitting..." pendant le délai */}
                                </button>
                            </div>
                        </form>
                    </Col>
                </Row>
            </div>
        </Col>
    );
};
